(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQ"] && !Shopify.designMode) return;
  try {
    
  // Find all accordion items
  var accordionItems = document.querySelectorAll('.accordion-item');

  // Add event listener to each accordion header
  accordionItems.forEach(function (item) {
    var header = item.querySelector('.accordion-header');
    header.addEventListener('click', function () {
      // Toggle active class on clicked item
      item.classList.toggle('active');
      // Toggle content display on clicked item
      var content = item.querySelector('.accordion-content');
      content.style.display = content.style.display === 'block' ? 'none' : 'block';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["repeatable-blocks-2"] && !Shopify.designMode) return;
  try {
    
  /* Add any necessary JavaScript here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["repeatable-blocks"] && !Shopify.designMode) return;
  try {
    
  /* Add any necessary JavaScript here */

  } catch(e) { console.error(e); }
})();
})();
